export enum DocumentStatus {
  HardDelete = -1,
  Current = 0,
  SoftDelete = 1,
  New = 2
}